import React, { Fragment } from 'react'
import {
    useTable,
    useGlobalFilter,
    useSortBy,
    useFilters,
    useExpanded,
    usePagination,
} from "react-table"
import { Table, Row, Col, Button } from "reactstrap"
import SearchFilter from './SearchFilter'
import { generateSortingIndicator } from 'helpers/table-sorting'

const CommonTable = ({
    columns,
    data,
    heading = "",
    isResizeTable = true,
    customSearchBar = false,
    headerHtml = false,
    children
}) => {

    // main table initialization
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state,
        preGlobalFilteredRows,
        setGlobalFilter,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: 0,
                pageSize: 25,
                sortBy: [
                    {
                        desc: true,
                    },
                ],
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination
    )

    const onChangeInSelect = event => {
        setPageSize(Number(event.target.value))
    }

    return (
        <div> 

            <div className="mb-3 d-flex justify-content-between align-items-center flex-md-row flex-column-reverse">
                <div>
                    <h5 className="fw-bold text-capitalize">{heading}</h5>
                </div>
                <div className="d-flex justify-content-end">
                    <div className="d-md-block d-none ">
                        {
                            customSearchBar ? customSearchBar :
                                <SearchFilter
                                    preGlobalFilteredRows={preGlobalFilteredRows}
                                    globalFilter={state.globalFilter}
                                    setGlobalFilter={setGlobalFilter}
                                />
                        }
                    </div>

                    {
                        isResizeTable &&
                        <div className="ms-3">
                            <select
                                className="form-select "
                                value={pageSize}
                                onChange={onChangeInSelect}
                            >
                                {[25, 50, 100, 200].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        Show {pageSize}
                                    </option>
                                ))}
                            </select>
                        </div>
                    }

                    {children}

                </div>
            </div>


            <div className="table-responsive table-header-height fixed-table-header">
                <Table
                    bordered
                    {...getTableProps()}
                    className="w-800 responsive-table"
                    style={{ verticalAlign: 'middle' }}
                >
                    <thead className=" table-header table-primary">
                        {headerGroups.map(headerGroup => (
                            <tr
                                key={headerGroup.id}
                                {...headerGroup.getHeaderGroupProps()}
                            >
                                {headerGroup.headers.map(column => (
                                    <th key={column.id} className={column.className}>
                                        <div {...column.getSortByToggleProps()} className="justify-content-between d-flex align-items-center">
                                            {column.render("Header") || headerHtml}
                                            {column.disableSort ? null : generateSortingIndicator(column)}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {page.map(row => {
                            prepareRow(row)
                            return (
                                <Fragment key={row.getRowProps().key}>
                                    <tr className="row-hover">
                                        {row.cells.map(cell => {
                                            return (
                                                <td key={cell.id} className={cell.column.className} data-label={cell.column.Header} {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                </Fragment>
                            )
                        })}

                        {
                            page.length === 0 && <tr>
                                <td colSpan={columns?.length} className="text-center text-capitalize">No Record Found!</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center mt-3">
                <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                        <Button
                            className="bg-blue"
                            color="primary"
                            onClick={() => gotoPage(0)}
                            disabled={!canPreviousPage}
                        >
                            {"<<"}
                        </Button>
                        <Button
                            className="bg-blue"
                            color="primary"
                            onClick={previousPage}
                            disabled={!canPreviousPage}
                        >
                            {"<"}
                        </Button>
                    </div>
                </Col>
                <Col className="col-md-auto d-none d-md-block">
                    Page{" "}
                    <strong>
                        {pageOptions.length ? pageIndex + 1 : pageIndex} of {pageOptions.length}
                    </strong>
                </Col>

                <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                        <Button
                            className="bg-blue"
                            color="primary"
                            onClick={nextPage}
                            disabled={!canNextPage}
                        >
                            {">"}
                        </Button>
                        <Button
                            className="bg-blue"
                            color="primary"
                            onClick={() => gotoPage(pageCount - 1)}
                            disabled={!canNextPage}
                        >
                            {">>"}
                        </Button>
                    </div>
                </Col>
            </Row>

        </div>
    )
}

export default CommonTable